import React, { useState, useEffect, useCallback, useRef } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Country } from "country-state-city";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Select from "react-select";

//imported
import { USERS } from "helpers/viewContent";
import {
  addData_,
  getDetail_,
  updateData_,
} from "store/services/commonService";
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import { uploadFile_ } from "helpers/uploadFile";
import {
  validateNullEmptyValue,
  validateEditEmptyValues,
  FORMAT_TEXT_VALUE,
} from "helpers/common";
import { MAIN__DUMMY_ } from "utils/constant";
import GooglePlaces from "components/shared/GooglePlaces";
import { ERROR_MESSAGE } from "helpers/constantsMessage";
import Classification from "./Classification";
import Preferrences from "./Preferrences";
import Guardian from "./Guardian";
import moment from "moment";


const validationSchemaforEdit = Yup.object().shape({
  // name: Yup.string().required('Full name is required'),
  name: Yup.string().optional(),
  last_name: Yup.string().optional(),
  gender: Yup.string().optional(),
  platform_joining_type: Yup.string().optional(),
  birth_date: Yup.string().optional(),
  phone: Yup.string().optional(),
  nationality: Yup.string().optional(),
  player_statistics: Yup.string().optional(),
  player_style: Yup.string().optional(),
  height: Yup.string().optional(),
  image: Yup.string().optional(),
  weight: Yup.string().optional(),
  preferred_playing_surface: Yup.string().optional(),
  // preferred_age: Yup.string().optional(),
  location: Yup.string().optional(),
  // city: Yup.string().required('City is required'),
  // state: Yup.string().required('State is required'),
  // zip_code: Yup.string().required('Zipcode is required'),
  email: Yup.string().email("Invalid email address").optional(),
  single_rating: Yup.string().optional(),
  utr_single_rating: Yup.string().optional(),
  password: Yup.string().optional(),
  parent_name: Yup.string().optional(),
  parent_last_name: Yup.string().optional(),
  relationship: Yup.string().optional(),
  children_details: Yup.string().optional(),
});

const AddEdit = ({ dispatch, match, editIdProps }) => {
  const [weekPreferences, setweekPreferences] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [editData, setEditData] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [imageData, setImageData] = useState("");
  const [changePassword, setChangePassword] = useState(false);
  const [countryListing, setCountryListing] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [playerAge, setPlayerAge] = useState(null);
  //home court address
  const [homeCourtAddressField, setHomeCourtAddressField] = useState([]);
  //classifications
  const [universityAttends, setUniversityAttends] = useState([]);
  const [tournamentsAttends, setTournamentsAttends] = useState([]);
  const [leaguesAttends, setLeaguesAttends] = useState([]);
  const [gardians, setGardians] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  //password
  const [showPassword, setShowPassword] = useState(false);
  const history = useHistory();

  const [fields, setfields] = useState({
    name: "",
    last_name: "",
    gender: "",
    birth_date: "",
    nationality: "",
    player_statistics: "",
    player_style: "",
    height: "",
    weight: "",
    image: "",
    bio: "",
    preferred_playing_surface: "",
    // preferred_age: "",
    utr_single_rating: "",
    single_rating: "",
    email: "",
    location: "",
    latitude: "",
    longitude: "",
    phone: "",
    country_code: "",
    password: "",
    platform_joining_type: "",
    city: "",
    state: "",
    zip_code: "",
    player_classification: "",
    academy_name: "",
    hight_school: "",
    graduation_year: "",
    universities_attend: "",
    college: "",
    major: "",
    training_facility: "",
    tournaments: "",
    profession: "",
    leagues_play: "",
    self_ranking: "",
    preferred_playing_surface: "",
    home_court_address: "",
    home_court_surface_type: "",
    playing_mode: "",
    opponent_gender: "",
    max_opponent_age: "",
    min_opponent_age: "",
    status: "1",
    parent_name: "",
    parent_last_name: "",
    relationship: "",
    children_details: "",
  });


  const validationSchema = Yup.object().shape({
    // name: Yup.string().required('Full name is required'),
    name: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Only text characters are allowed in the name")
      .required("First name is required"),
    last_name: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Only text characters are allowed in the name")
      .required("Last name is required"),
    gender: Yup.string().required("Gender is required"),
    platform_joining_type: Yup.string().required(
      "Platform joining type is required"
    ),
    birth_date: Yup.string().required("Birth Date is required"),
    phone: Yup.string().required("Phone number is required"),
    nationality: Yup.string().required("Nationality is required"),
    player_statistics: Yup.string().required("Player Statistics is required"),
    player_style: Yup.string().required("Playing Style is required"),
    height: Yup.string().required("Height is required"),
    image: Yup.string().optional(),
    weight: Yup.string().required("Weight is required"),
    preferred_playing_surface: Yup.string().required(
      "Preferred playing surfaces is required"
    ),
    // preferred_age: Yup.string().required("Preferred age range is required"),
    location: Yup.string().required("Location is required"),
    // city: Yup.string().required('City is required'),
    // state: Yup.string().required('State is required'),
    // zip_code: Yup.string().required('Zipcode is required'),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    single_rating: Yup.string().required("Required"),
    utr_single_rating: Yup.string().required("Required"),
    password: Yup.string().min(6, "Password must be at least 6 characters"),
    parent_name:
      (fields.platform_joining_type || 0) === "2"
        ? Yup.string()
          .matches(
            /^[A-Za-z\s]+$/,
            "Only text characters are allowed in the name"
          )
          .required("Parent First name is required")
        : Yup.string().optional(),
    parent_last_name:
      (fields.platform_joining_type || 0) === "2"
        ? Yup.string()
          .matches(
            /^[A-Za-z\s]+$/,
            "Only text characters are allowed in the name"
          )
          .required("Parent Last name is required")
        : Yup.string().optional(),
    relationship:
      fields.platform_joining_type === "2"
        ? Yup.string().required("Required")
        : Yup.string().optional(),
    children_details:
      fields.platform_joining_type === "2"
        ? Yup.string().required("Required")
        : Yup.string().optional(),
  });

  const fileInputRef = useRef(null);

  let editkey = match.params.id
    ? match.params.id
    : editIdProps
      ? editIdProps
      : "";

  const validateData = async (data) => {
    try {
      editkey ? await validationSchemaforEdit.validate(data, { abortEarly: false }) : await validationSchema.validate(data, { abortEarly: false });
      return { isValid: true, errors: {} };
    } catch (error) {
      console.log("error here", error);
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      return { isValid: false, errors };
    }
  };

  const isValidDate = (current) => {
    const currentDate = new Date();
    return current.isBefore(currentDate, "day");
  };

  //password show
  const togglePasswordVisiblity = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = useCallback(
    (name) => (evt) => {
      setfields((prevState) => ({
        ...prevState,
        [name]: evt.target.value,
      }));
      setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    },
    []
  );

  const handlechangesetSelectedOption = (selectedOption) => {
    let prefferredSurface = [];
    for (let val of selectedOption) {
      prefferredSurface.push(val.value);
    }
    setfields((prevState) => ({
      ...prevState,
      preferred_playing_surface:
        selectedOption.length > 0 ? JSON.stringify(prefferredSurface) : "",
    }));
    setSelectedOption(selectedOption);

    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      preferred_playing_surface: "",
    }));
  };
  const changePasswordToogle = () => {
    setChangePassword(!changePassword);
  };

  const handleChangePicker = async (selectedDate, name) => {
    // Perform actions based on the selected date and field name
    let dateFormat2 = selectedDate ? selectedDate.format("YYYY-MM-DD") : "";
    let dateFormat = selectedDate ? moment(selectedDate, "YYYY-MM-DD") : "";
    let currentDate = moment(); // Current date
    let ageDifference = currentDate.diff(dateFormat, "years");
    setPlayerAge(ageDifference);
    setfields((prev) => ({
      ...prev,
      [name]: dateFormat2,
    }));
    setValidationErrors({ [name]: "" });
    // Rest of your code...
  };

  const handleFileChange = async (e) => {
    try {
      e.preventDefault();
      const file = e.target.files[0];
      let fileName = e.target.name;
      dispatch(actions.persist_store({ loader: true }));
      // setIsShow(true);
      // setSending(true);
      let data = await uploadFile_(
        dispatch,
        file,
        setValidationErrors,
        setSelectedFile,
        setPreviewImage,
        fileName
      );
      data = data?.length > 0 ? data : [];
      dispatch(actions.persist_store({ loader: false }));
      setIsShow(false);
      setSending(false);
      setImageData(data?.length > 0 ? data[0]?.image_url : "");
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleDrop = async (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    await uploadFile_(file);
  };
  const handleClick = () => {
    fileInputRef.current.click();
  };
  async function getData() {
    try {
      let query = {
        url: "user/view",
        id: editkey,
      };
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getDetail_(query));
      let resData = res?.body;
      let obj = {
        ...resData,
        password:"",
        academy_name: resData?.user_detail?.academy_name,
        college: resData?.user_detail?.college,
        graduation_year: resData?.user_detail?.graduation_year,
        home_court_address: resData?.user_detail?.home_court_address,
        hight_school: resData?.user_detail?.hight_school,
        home_court_surface_type: resData?.user_detail?.home_court_surface_type,
        major: resData?.user_detail?.major,
        playing_mode: resData?.user_detail?.playing_mode,
        training_facility: resData?.user_detail?.training_facility,
        self_ranking: resData?.user_detail?.self_ranking,
        player_classification: resData?.user_detail?.player_classification,
        universities_attend:
  resData?.user_detail?.universities_attend &&
  resData?.user_detail?.universities_attend !== "0"
    ? JSON.parse(resData?.user_detail?.universities_attend)
    : [],
        tournaments: resData?.user_detail?.tournaments
          ? JSON.parse(resData?.user_detail?.tournaments)
          : [],
        leagues_play: resData?.user_detail?.leagues_play
          ? JSON.parse(resData?.user_detail?.leagues_play)
          : [],
        parent_name: resData?.players_parent_info?.parent_name,
        parent_last_name: resData?.players_parent_info?.parent_last_name,
        relationship: resData?.players_parent_info?.relationship,
        children_details: resData?.players_parent_info?.children_details || "",
      };
      setEditData(obj);
      setfields(obj);
      setUniversityAttends(obj?.universities_attend==="0"?[]:(obj?.universities_attend));
      setTournamentsAttends(obj?.tournaments);
      setLeaguesAttends(obj?.leagues_play);
      setHomeCourtAddressField(resData?.home_court_addresses);
      let surfaceVal = resData?.preferred_playing_surface;
      surfaceVal = surfaceVal ? JSON.parse(surfaceVal) : [];
      let editSurfaceArr = [];
      for (let surface of surfaceVal) {
        let obj = {
          label: await FORMAT_TEXT_VALUE(surface),
          value: surface,
        };
        editSurfaceArr.push(obj);
      }
      setSelectedOption(editSurfaceArr);
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }

  useEffect(() => {
    const data = Country.getAllCountries().map((country) => ({
      value: country.name,
      displayValue: `${country.name} - ${country.isoCode}`,
    }));
    setCountryListing(data);
  }, []);

  useEffect(() => {
    if (editkey) {
      getData();
    }
  }, []);

  useEffect(() => {
    if (tabIndex == 1) {
      getData();
    }
  }, [tabIndex]);

  console.log(fields)
  //submit setting data
  const handleSubmit = async (evt) => {
    try {
      evt.preventDefault();
      setChangePassword(false)
      const validation = await validateData(fields);
      if (validation.isValid) {
        let dateFormat = fields?.birth_date
          ? moment(fields?.birth_date, "YYYY-MM-DD")
          : "";
        let currentDate = moment(); // Current date
        let ageDifference = currentDate.diff(dateFormat, "years");
        let ageDifference_ = playerAge ? playerAge : ageDifference;
        if (!editkey && ageDifference_ < 18 && fields.platform_joining_type !== "2") {
          await ERROR_MESSAGE(
            "Validation error!! Parent information is required for you"
          );
        } else {
          dispatch(actions.persist_store({ loader: true }));
          let query = {};
          query.image = imageData ? imageData : fields.image;
          if (homeCourtAddressField?.length > 0) {
            query.home_court_arr = JSON.stringify(homeCourtAddressField);
          }
          fields.role = "1";
          fields.age = playerAge;
          if (editkey) {
            fields.password_update = changePassword;
            if (!changePassword) {
              delete fields.password;
            }
            query = {
              ...fields,
              ...query,
              url: "user/edit",
              id: editkey,
            };
            if (universityAttends.length > 0) {
              query.universities_attend = JSON.stringify(universityAttends);
            }
            if (leaguesAttends.length > 0) {
              query.leagues_play = JSON.stringify(leaguesAttends);
            }
            if (tournamentsAttends.length > 0) {
              query.tournaments = JSON.stringify(tournamentsAttends);
            }
            if (weekPreferences.length > 0) {
              query.weeks = JSON.stringify(weekPreferences);
            }

            let finalVal_ = await validateEditEmptyValues(query);
            setIsShow(true);
            if (
              tabIndex == 1 &&
              finalVal_.player_classification !== "none" &&
              finalVal_.player_classification !== ""
            ) {
              await dispatch(updateData_(finalVal_));
            } else if (
              tabIndex == 2 &&
              finalVal_.preferred_playing_surface !== ""
            ) {
              await dispatch(updateData_(finalVal_));
            } else if (tabIndex == 0) {
              await dispatch(updateData_(finalVal_));
            }
            setIsShow(false);
            if (tabIndex == 0) {
              setTabIndex(1);
            } else if (tabIndex == 1) {
              setTabIndex(2);
            } else {
              dispatch(actions.persist_store({ editIdProps: null }));
              history.push(Path.users);
            }
          } else {
            setIsShow(true);
            let finalVal = await validateNullEmptyValue(fields);
            query = {
              ...finalVal,
              ...query,
              url: "user/add",
            };
            // return
            let res = await dispatch(addData_(query));
            if (res?.data?.body) {
              dispatch(
                actions.persist_store({ editIdProps: res?.data?.body?.id })
              );
            }
            setTabIndex(1);
            setIsShow(false);
          }
        }
      } else {
        console.log(validation)
        setValidationErrors(validation.errors);
        await ERROR_MESSAGE("Validation error!! Pleas check all fields");
      }
    } catch (err) {
      setIsShow(false);
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    } finally {
      dispatch(actions.persist_store({ loader: false }));
    }
  };
  const select_options = [
    { value: "all", label: "All" },
    { value: "hardCourt", label: "Hardcourt" },
    { value: "clay", label: "Clay" },
    { value: "indoor", label: "Indoor" },
    { value: "grass", label: "Grass" },
  ];
  return (
    <>
      <Helmet title={USERS.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-contacts menu-icon"></i>
          </span>
          {USERS.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.users}>User</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Add/Edit
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card profile-card">
            <div className="card-body">
              <h4 className="card-title">Add/Edit</h4>
              <Tabs selectedIndex={tabIndex} >
                <TabList>
                  <Tab>Personal Detail</Tab>
                  <Tab>Playing Classification</Tab>
                  <Tab>Match Preferrences</Tab>
                </TabList>
                {/* <form className="forms-sample" onSubmit={handleSubmit}> */}
                <TabPanel>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="gender">
                        Joining as a player or a player/parent {editkey ? "" : "*"}
                      </label>
                      <div className="col-md-12">
                        <select
                          className="form-select"
                          name="platform_joining_type"
                          onChange={handleChange("platform_joining_type")}
                          value={fields.platform_joining_type}
                        >
                          <option value="" selected disabled>
                            Select
                          </option>
                          <option
                            value="1"
                            selected={
                              (fields?.platform_joining_type || "0") === "1"
                                ? "selected"
                                : ""
                            }
                          >
                            Player
                          </option>
                          <option
                            value="2"
                            selected={
                              (fields?.platform_joining_type || "0") === "2"
                                ? "selected"
                                : ""
                            }
                          >
                            Parent/Guardian
                          </option>
                        </select>
                        {validationErrors?.platform_joining_type && (
                          <div className="text-danger err">
                            {validationErrors?.platform_joining_type}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {(fields?.platform_joining_type || "0") === "2" && (
                    <Guardian
                      fields={fields}
                      validationErrors={validationErrors}
                      handleChange={handleChange}
                      gardians={gardians}
                      editkey={editkey}
                      setGardians={setGardians}
                    />
                  )}

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="name">First Name {editkey ? "" : "*"}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="First Name*"
                        name="name"
                        onChange={handleChange("name")}
                        value={fields?.name}
                      />
                      {validationErrors?.name && (
                        <div className="text-danger err">
                          {validationErrors?.name}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="last_name">Last Name {editkey ? "" : "*"}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="Last Name*"
                        name="last_name"
                        onChange={handleChange("last_name")}
                        value={fields?.last_name}
                      />
                      {validationErrors?.last_name && (
                        <div className="text-danger err">
                          {validationErrors?.last_name}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="email">E-mail {editkey ? "" : "*"}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="E-mail*"
                        name="email"
                        onChange={handleChange("email")}
                        value={fields?.email}
                      />
                      {validationErrors?.email && (
                        <div className="text-danger err">
                          {validationErrors?.email}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="gender">Gender {editkey ? "" : "*"}</label>
                      <div className="col-md-12">
                        <select
                          className="form-select"
                          name="gender"
                          onChange={handleChange("gender")}
                          value={fields?.gender}
                        >
                          <option value="" selected disabled>
                            Select
                          </option>
                          <option
                            value="1"
                            selected={fields?.gender === "1" ? "selected" : ""}
                          >
                            Male
                          </option>
                          <option
                            value="2"
                            selected={fields?.gender === "2" ? "selected" : ""}
                          >
                            Female
                          </option>
                          <option
                            value="3"
                            selected={fields?.gender === "3" ? "selected" : ""}
                          >
                            Other
                          </option>
                        </select>
                        {validationErrors?.gender && (
                          <div className="text-danger err">
                            {validationErrors?.gender}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label for="exampleInputEmail3">Date of Birth {editkey ? "" : "*"}</label>
                      <Datetime
                        value={fields.birth_date || ""}
                        inputProps={{
                          placeholder: "YYYY-MM-DD",
                          readOnly: true,
                        }}
                        name="birth_date"
                        dateFormat="YYYY-MM-DD"
                        timeFormat={false}
                        isValidDate={isValidDate}
                        onChange={(selectedDate) =>
                          handleChangePicker(selectedDate, "birth_date")
                        }
                        closeOnSelect={true}
                      />
                      {validationErrors?.birth_date && (
                        <div className="text-danger err">
                          {validationErrors?.birth_date}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label for="exampleInputName1">Phone Number {editkey ? "" : "*"}</label>
                      <div className="col-md-12">
                        <PhoneInput
                          enableAreaCodes={true}
                          name="phone"
                          className="form-phone_"
                          country={"us"} // Set the default country, or the one relevant to your use case
                          value={`${fields?.country_code}${fields?.phone}`} // Provide the value for the PhoneInput
                          onChange={(value, country) => {
                            setfields((prevState) => ({
                              ...prevState,
                              phone: value.slice(country.dialCode.length),
                              country_code: "+"+country.dialCode,
                            }));
                            setValidationErrors({ phone: "" });
                          }}
                          maxLength={15}
                        />
                      </div>
                      {validationErrors?.phone && (
                        <div className="text-danger err">
                          {validationErrors?.phone}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group  col-md-6">
                      <label for="exampleInputPassword4">Nationality {editkey ? "" : "*"}</label>
                      <select
                        className="form-select"
                        name="nationality"
                        onChange={handleChange("nationality")}
                        value={fields?.nationality}
                      >
                        <option value="" selected disabled>
                          Select
                        </option>
                        {countryListing?.length > 0 &&
                          countryListing.map((op, i) => {
                            return (
                              <option key={i} value={op.value} selected>
                                {op.displayValue}
                              </option>
                            );
                          })}
                      </select>
                      {validationErrors?.nationality && (
                        <div className="text-danger err">
                          {validationErrors?.nationality}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label for="exampleInputName1">Location {editkey ? "" : "*"}</label>
                      <div className="col-md-12">
                        <GooglePlaces
                          setfields={setfields}
                          fields={fields}
                          value={fields.location || ""}
                          setValidationErrors={setValidationErrors}
                          fieldNames={["location", "latitude", "longitude"]}
                        />
                        {validationErrors?.location && (
                          <div className="text-danger err">
                            {validationErrors?.location}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="CITY">City</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="City"
                        name="city"
                        onChange={handleChange("city")}
                        value={fields.city}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="state">State</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="State"
                        name="state"
                        onChange={handleChange("state")}
                        value={fields.state}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="zip_code">Zipcode</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="Zipcode"
                        name="zip_code"
                        onChange={handleChange("zip_code")}
                        value={fields.zip_code}
                      />
                    </div>
                  </div>
                  <div className="row">
                    {editkey && (
                      <div className="form-group col-md-6">
                        <label for="exampleInputName1">
                          You want to change password
                        </label>
                        <div className="col-md-12">
                          <div className="form-check">
                            <label className="form-check-label">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                onClick={changePasswordToogle}
                              />
                              {"Yes"}
                              <i className="input-helper"></i>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                    {(changePassword || !editkey) && (
                      <div className="form-group col-md-6">
                        <label for="exampleInputName1">Password {editkey ? "" : "*"}</label>
                        <div className="col-md-12">
                          <div className="form-group">
                            <div className="input-group">
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Password*"
                                value={fields.password}
                                onChange={handleChange("password")}
                                autoComplete="new-password"
                              />
                              <div
                                className="input-group-append"
                                onClick={togglePasswordVisiblity}
                              >
                                <button
                                  className="btn btn-bl btn-facebook"
                                  type="button"
                                >
                                  <i
                                    className={
                                      showPassword
                                        ? "mdi mdi-eye"
                                        : "mdi mdi-eye-off"
                                    }
                                  ></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          {validationErrors?.password && (
                            <div className="text-danger err">
                              {validationErrors?.password}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="WTN">WTN rating {editkey ? "" : "*"}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="WTN rating"
                        name="single_rating"
                        onChange={handleChange("single_rating")}
                        value={fields.single_rating}
                        min={0}
                      />
                      {validationErrors?.single_rating && (
                        <div className="text-danger err">
                          {validationErrors?.single_rating}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="single_rating">UTR rating {editkey ? "" : "*"}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="UTR rating"
                        name="utr_single_rating"
                        onChange={handleChange("utr_single_rating")}
                        value={fields.utr_single_rating}
                        min={0}
                      />
                      {validationErrors?.utr_single_rating && (
                        <div className="text-danger err">
                          {validationErrors?.utr_single_rating}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group  col-md-6">
                      <label for="exampleInputName1">Player Statistics {editkey ? "" : "*"}</label>
                      <div className="col-md-12">
                        <select
                          className="form-select"
                          name="player_statistics"
                          onChange={handleChange("player_statistics")}
                          value={fields.player_statistics}
                        >
                          <option value="" selected disabled>
                            Select
                          </option>
                          <option
                            value="right"
                            selected={
                              fields?.player_statistics === "right"
                                ? "selected"
                                : ""
                            }
                          >
                            Playing Hand: Right-handed
                          </option>
                          <option
                            value="left"
                            selected={
                              fields?.player_statistics === "left"
                                ? "selected"
                                : ""
                            }
                          >
                            Playing Hand: Left-handed
                          </option>
                          <option
                            value="singles"
                            selected={
                              fields?.player_statistics === "singles"
                                ? "selected"
                                : ""
                            }
                          >
                            Singles
                          </option>
                          <option
                            value="doubles"
                            selected={
                              fields?.player_statistics === "doubles"
                                ? "selected"
                                : ""
                            }
                          >
                            Doubles Player
                          </option>
                        </select>
                        {validationErrors?.player_statistics && (
                          <div className="text-danger err">
                            {validationErrors?.player_statistics}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group  col-md-6">
                      <label for="exampleInputName1">Playing Style {editkey ? "" : "*"}</label>
                      <div className="col-md-12">
                        <select
                          className="form-select"
                          name="player_style"
                          onChange={handleChange("player_style")}
                          value={fields.player_style}
                        >
                          <option value="" selected disabled>
                            Select
                          </option>
                          <option
                            value="allcourt"
                            selected={
                              fields?.player_style === "allcourt"
                                ? "selected"
                                : ""
                            }
                          >
                            All Court
                          </option>
                          <option
                            value="aggressive"
                            selected={
                              fields?.player_style === "aggressive"
                                ? "selected"
                                : ""
                            }
                          >
                            Aggressive
                          </option>
                          <option
                            value="solidBaseliner"
                            selected={
                              fields?.player_style === "solidBaseliner"
                                ? "selected"
                                : ""
                            }
                          >
                            Solid Baseline
                          </option>
                          <option
                            value="counterPuncher"
                            selected={
                              fields?.player_style === "counterPuncher"
                                ? "selected"
                                : ""
                            }
                          >
                            Counter Puncher
                          </option>
                          <option
                            value="bigServer"
                            selected={
                              fields?.player_style === "bigServer"
                                ? "selected"
                                : ""
                            }
                          >
                            Big Server
                          </option>
                          <option
                            value="serveandVolley"
                            selected={
                              fields?.player_style === "serveAndVolley"
                                ? "selected"
                                : ""
                            }
                          >
                            Serve and Volley
                          </option>
                        </select>
                        {validationErrors?.player_style && (
                          <div className="text-danger err">
                            {validationErrors?.player_style}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group  col-md-6">
                      <label for="exampleInputName1">Height {editkey ? "" : "*"}</label>
                      <div className="col-md-12">
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputName1"
                          placeholder="inch"
                          name="height"
                          onChange={handleChange("height")}
                          value={fields.height}
                        />
                        {validationErrors?.height && (
                          <div className="text-danger err">
                            {validationErrors?.height}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label for="exampleInputName1">Weight {editkey ? "" : "*"}</label>
                      <div className="col-md-12">
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputName1"
                          placeholder="kg"
                          name="weight"
                          onChange={handleChange("weight")}
                          value={fields.weight}
                        />
                        {validationErrors?.weight && (
                          <div className="text-danger err">
                            {validationErrors?.weight}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label for="exampleInputName1">
                        Preferred Playing Surfaces {editkey ? "" : "*"}
                      </label>
                      <div className="col-md-12">
                        <Select
                          value={selectedOption}
                          onChange={(selectedOption) =>
                            handlechangesetSelectedOption(selectedOption)
                          }
                          options={select_options}
                          isMulti={true}
                        />
                        {validationErrors?.preferred_playing_surface && (
                          <div className="text-danger err">
                            {validationErrors?.preferred_playing_surface}
                          </div>
                        )}
                        {/* <select
                          className="form-select"
                          name="preferred_playing_surface"
                          onChange={handleChange("preferred_playing_surface")}
                          value={fields.preferred_playing_surface}
                          multiple
                        >
                          <option value="" selected disabled>
                            Select
                          </option>
                          <option
                            value="all"
                            selected={
                              fields?.preferred_playing_surface === "all"
                                ? "selected"
                                : ""
                            }
                          >
                            All
                          </option>
                          <option
                            value="hardCourt"
                            selected={
                              fields?.preferred_playing_surface === "hardCourt"
                                ? "selected"
                                : ""
                            }
                          >
                            Hard Court
                          </option>
                          <option
                            value="clay"
                            selected={
                              fields?.preferred_playing_surface === "clay"
                                ? "selected"
                                : ""
                            }
                          >
                            Clay
                          </option>
                          <option
                            value="indoor"
                            selected={
                              fields?.preferred_playing_surface === "indoor"
                                ? "selected"
                                : ""
                            }
                          >
                            Indoor
                          </option>
                          <option
                            value="grass"
                            selected={
                              fields?.preferred_playing_surface === "grass"
                                ? "selected"
                                : ""
                            }
                          >
                            Grass
                          </option>
                        </select> */}
                      </div>
                    </div>
                    {/* <div className="form-group col-md-6">
                      <label for="exampleInputName1">
                        Preferred Age Range {editkey ? "" : "*"}
                      </label>
                      <div className="col-md-12">
                        <input
                          type="number"
                          className="form-control"
                          id="exampleInputName1"
                          placeholder="Preferred Age Range*"
                          name="preferred_age"
                          min={0}
                          onChange={handleChange("preferred_age")}
                          value={fields.preferred_age}
                        />
                        {validationErrors?.preferred_age && (
                          <div className="text-danger err">
                            {validationErrors?.preferred_age}
                          </div>
                        )}
                      </div>
                    </div> */}
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label for="exampleInputName1">Bio</label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="exampleInputName1"
                        placeholder="Bio"
                        name="bio"
                        onChange={handleChange("bio")}
                        value={fields.bio}
                      />
                      {validationErrors?.bio && (
                        <div className="text-danger err">
                          {validationErrors?.bio}
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onClick={handleClick}
                  >
                    <div className="form-group">
                      <label for="exampleInputEmail3">Profile Picture</label>
                      <input
                        type="file"
                        class="form-control file-upload-info"
                        disabled=""
                        placeholder="Upload Image"
                        style={{ display: "none" }}
                        name="image"
                        onChange={(e) => handleFileChange(e)}
                        ref={fileInputRef}
                      />
                      <div>
                        {previewImage ? (
                          <img
                            src={previewImage}
                            alt="Preview"
                            className="img-custom"
                          />
                        ) : editData?.image ? (
                          <img
                            src={editData?.image}
                            alt="Preview"
                            className="img-custom"
                          />
                        ) : (
                          <img
                            src={MAIN__DUMMY_}
                            alt="Default Preview"
                            className="img-custom"
                          />
                        )}
                      </div>
                      {validationErrors?.image && (
                        <div className="text-danger err">
                          {validationErrors?.image}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <label for="exampleInputPassword4">Status {editkey ? "" : "*"}</label>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="">
                            <input
                              type="radio"
                              className=""
                              value={"1"}
                              name="status"
                              onChange={handleChange("status")}
                              checked={fields.status === "1" ? true : false}
                            />
                            Active
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="">
                            <input
                              type="radio"
                              className=""
                              value={"0"}
                              name="status"
                              onChange={handleChange("status")}
                              checked={fields.status === "0" ? true : false}
                            />
                            Inactive
                          </label>
                        </div>
                      </div>
                    </div>
                    {validationErrors?.status && (
                      <div className="text-danger err">
                        {validationErrors?.status}
                      </div>
                    )}
                  </div>
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    disabled={isShow ? true : false}
                    className="btn btn-gradient-primary me-2"
                  >
                    {isShow ? "Wait.." : "Next"}
                  </button>
                  <Link to={Path.users}>
                    <button className="btn btn-outline-secondary btn-lg">
                      Back
                    </button>
                  </Link>
                </TabPanel>
                <TabPanel>
                  <Classification
                    fields={fields}
                    validationErrors={validationErrors}
                    handleChange={handleChange}
                    universityAttends={universityAttends}
                    setUniversityAttends={setUniversityAttends}
                    tournamentsAttends={tournamentsAttends}
                    setTournamentsAttends={setTournamentsAttends}
                    leaguesAttends={leaguesAttends}
                    setLeaguesAttends={setLeaguesAttends}
                  />
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    disabled={isShow ? true : false}
                    className="btn btn-gradient-primary me-2"
                  >
                    {isShow ? "Wait.." : "Next"}
                  </button>
                  <button
                    className="btn btn-outline-secondary btn-lg"
                    onClick={() => setTabIndex(0)}
                  >
                    Back
                  </button>
                </TabPanel>
                <TabPanel>
                  <Preferrences
                    fields={fields}
                    validationErrors={validationErrors}
                    handleChange={handleChange}
                    weekPreferences={weekPreferences}
                    setweekPreferences={setweekPreferences}
                    editData={editData?.weeks_preferences}
                    select_options={select_options}
                    setSelectedOption={setSelectedOption}
                    selectedOption={selectedOption}
                    setHomeCourtAddressField={setHomeCourtAddressField}
                    homeCourtAddressField={homeCourtAddressField}
                  />
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    disabled={isShow ? true : false}
                    className="btn btn-gradient-primary me-2"
                  >
                    {isShow ? "Wait.." : "Submit"}
                  </button>
                  <button
                    onClick={() => setTabIndex(1)}
                    className="btn btn-outline-secondary btn-lg"
                  >
                    Back
                  </button>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    editIdProps: state?.persistStore?.editIdProps,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(AddEdit);
